var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddCloud2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "40px",
    viewBox: "0 0 46 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 1081") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_CompanyDESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM-New-Install",
    transform: "translate(-698.000000, -821.000000)",
    fill: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(605.000000, 821.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1081",
    transform: "translate(93.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,30 L24,30 L24,34 C24,34.55 23.55,35 23,35 C22.448,35 22,34.55 22,34 L22,30 L18,30 C17.448,30 17,29.55 17,29 C17,28.448 17.448,28 18,27.986 L22,27.986 L22,24 C22,23.448 22.448,23 23,23 C23.55,23 24,23.448 24,24 L24,27.986 L28,27.986 C28.55,28 29,28.448 29,29 C29,29.55 28.55,30 28,30 M23,18 C16.934,18 12,22.934 12,29 C12,35.064 16.934,39.986 23,39.986 C29.064,39.986 34,35.064 34,29 C34,22.934 29.064,18 23,18",
    id: "Fill-2584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7040007,7.664 C33.2240007,2.988 28.3060007,0 23.0000007,0 C15.7640007,0 9.70400074,5.386 8.75400074,12.454 C4.02400074,12.094 -0.00199925516,15.902 7.44837321e-07,20.606 C7.44837321e-07,25.376 3.04800074,29 10.0520007,29 C9.46400074,21.304 15.5720007,15 23.0000007,15 C30.4340007,15 36.5380007,21.308 35.9500007,29 C38.3040007,29 46.0000007,26.39 46.0000007,18.214 C46.0000007,12.48 41.4040007,7.798 35.7040007,7.664",
    id: "Fill-2585"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddCloud2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_cloud_2.6aab985b3c7b36c41525ab765f3c20fd.svg";